import { AddToWinnerLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/positionTactics/AddToWinnerLine';
import { AddToWinnerTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/positions/addToWinner/AddToWinnerTacticPanel';
import { AddToWinnerWrapper } from '../../../../components/displays/tradeplans/softOrderModules/positionTacticModules/AddToWinnerModule/wrapper/AddToWinnerWrapper';
import AddToWinnerDocs from '../../../../components/forms/tradeplans/documentation/AddToWinnerDocumentation';
import AddToWinnerModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/positionTactics/modules/AddToWinnerModule';
import { AddToWinnerData } from './addToWinnerData.js';
import { validateAddToWinner } from './validateAddToWinner';

export const AddToWinner = {
  //data class
  dataStore: AddToWinnerData,

  //string constants
  name: 'ADD_TO_WINNER',
  tacticLabel: 'Add to Winner',
  addTacticLabel: 'Add Add to Winner',
  category: 'Position',

  // components
  tradePlanFormModule: AddToWinnerModule,
  tacticPanel: AddToWinnerTacticPanel,
  addTacticPanel: null,
  wrapper: AddToWinnerWrapper,
  chartSoftOrderComponent: AddToWinnerLine,
  documentation: AddToWinnerDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateAddToWinner,
};
